import { Button, type ButtonProps } from '@mui/material';
import type { To } from 'react-router';
import { Link as RouterLink } from 'react-router';
import withPermission from './withPermission';

type AppLinkButtonProps = {
  permission: string;
  module: string;
  to: To;
} & ButtonProps;

const AppLinkButton = ({ module, permission, to, ...props }: AppLinkButtonProps) => {
  const newProps = { ...props, component: RouterLink, to };
  return withPermission(Button, module, permission, false)(newProps);
};

export default AppLinkButton;
